import { onPartLeadTimeChange } from '../../calculations/recalculate';
import { validatePriceLeadTime } from '../../validations/lead-time-price';
import { PriceFieldHandlerParams } from './types';

export function handlePartLeadTimeFieldChange({
  state,
  quoteLineUuid,
  quotePriceUuid,
  value,
}: PriceFieldHandlerParams) {
  const weeks = validatePriceLeadTime(state, {
    quoteLineUuid,
    quotePriceUuid,
    leadTime: value,
  });

  if (weeks == null) {
    return;
  }

  onPartLeadTimeChange(state, {
    quoteLineUuid,
    quotePriceUuid,
    leadTimeWeeks: weeks,
  });
}
